enum DriverContractAddBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export default DriverContractAddBillingModel;
